// extracted by mini-css-extract-plugin
export var header = "Header-module--header--3pj5E";
export var logotype = "Header-module--logotype--1inHg";
export var navigation = "Header-module--navigation--1WwxT";
export var link = "Header-module--link--1HfLk";